import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { LanguageProvider } from "./context/LanguageContext";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import CyberAttackPopup from "./components/CyberAttackPopup";
import ContactPopup from "./components/ContactPopup";
import EasterEgg from "./components/EasterEgg";
import Home from "./pages/Home";
import Management from "./pages/Management";
import Services from "./pages/Services";
import Zones from "./pages/Zones";
import Press from "./pages/Press";
import SpecialServices from "./pages/SpecialServices";
import Tetris from "./pages/Tetris";
import PressArticle from "./pages/PressArticle";
import AnnualReport from "./pages/AnnualReport";
import AgentNotifications from "./components/AgentNotifications";

function App() {
  return (
    <LanguageProvider>
      <BrowserRouter>
        <div className="App">
          <Navbar />
          <CyberAttackPopup />
          <ContactPopup />
          <EasterEgg />
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/management" element={<Management />} />
            <Route path="/services" element={<Services />} />
            <Route path="/zones" element={<Zones />} />
            <Route path="/press" element={<Press />} />
            <Route path="/press/:id" element={<PressArticle />} />
            <Route path="/special-services" element={<SpecialServices />} />
            <Route path="/bonus" element={<Tetris />} />
            <Route path="/rapport" element={<AnnualReport />} />
          </Routes>
          <Footer />
          <AgentNotifications />
        </div>
      </BrowserRouter>
    </LanguageProvider>
  );
}

export default App;
